import type {
  HTMLAttributes, PropsWithChildren,
} from 'react';
import { DividerComponent } from '~/_shared/baseComponents/divider';
import {
  dividerStyle, dividerWrapperStyle,
} from './mapOverlayPanel.styles';

export const MapOverlayDividerComponent = ({ children, ...restProps }: PropsWithChildren & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={dividerWrapperStyle}
      {...restProps}
    >
      <DividerComponent css={dividerStyle} />
      {children}
    </div>
  );
};
